import { render } from "./App.vue?vue&type=template&id=5ec7dfbe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5ec7dfbe&scss=true&lang=css"

import exportComponent from "D:\\job\\guobao\\guobao-ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__